// extracted by mini-css-extract-plugin
export default {"root":"n2xrZl","physicalLayout":"LNYNgf","logicalLayout":"JnQAfl","icon":"aTo_UF","visible":"wRGkgf","hidden":"JRUANI"};